import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { Grid, MenuItem, Select, Typography, Divider,IconButton,
  Collapse, } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { KeyboardArrowUp, KeyboardArrowDown } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
  bold: {
    fontWeight: 600,
  },
}));

export default function FormularioSolicitud(props) {
  const { register, errors, defaultItem, ctl, watch, setValue } = props;
  const classes = useStyles();
  const options = [
    { idestatus: 9, label: "Activo" },
    { idestatus: 10, label: "Inactivo" },
  ];

  // console.log(ctl);

  const [expanded1, setExpanded1] = useState(false);
  // const [value, setValue] = React.useState(options[0]);
  const [inputValue, setInputValue] = React.useState("");

  const handleExpandClick1 = () => {
    setExpanded1(!expanded1);
  };

  const handleChangePrioridad = (event, value) => {
    setValue("prioridad", value);
  };

  const handleChange = (event, value) => {
    setValue("responsable", value);
  };

  
  const suma_testeo_ma = ctl.infosolMalcance.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.hrs_testeo_ma), 0);
  const suma_revisiones_testeo_ma = ctl.infosolMalcance.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.revisiones_tester_ma), 0);

  return (
    <Grid container className={classes.root} spacing={2}>
      <Grid item md={1} xs={1}>
        <Typography variant="body2" className={classes.bold}>
          TIPO:
        </Typography>
      </Grid>
      <Grid item md={1} xs={1}>
        <Typography variant="body2">{ctl.infosol.ntipo_solicitud || "N/D"}</Typography>
      </Grid>
      <Grid item md={1} xs={1}>
        <Typography variant="body2" className={classes.bold}>
          PRIORIDAD:
        </Typography>
      </Grid>
      <Grid item md={1} xs={1}>
        <Typography variant="body2">{ctl.infosol.nprioridad || "N/D"}</Typography>
      </Grid>
      <Grid item md={1} xs={1}>
        <Typography variant="body2" className={classes.bold}>
          SISTEMA:
        </Typography>
      </Grid>
      <Grid item md={3} xs={3}>
        <Typography variant="body2">{ctl.infosol.proyectos || "N/D"}</Typography>
      </Grid>
      {/* <Grid item md={2} xs={3}>
        <Typography variant="body2" className={classes.bold}>
          Título:
        </Typography>
      </Grid>
      <Grid item md={3} xs={3}>
        <Typography variant="body2">{ctl.infosol.titulo || "N/D"}</Typography>
      </Grid> */}
      <Grid item md={1} xs={1}>
        <Typography variant="body2" className={classes.bold}>
          SOLICITANTE:
        </Typography>
      </Grid>
      <Grid item md={3} xs={3}>
        <Typography variant="body2">{ctl.infosol.solicitante || "N/D"}</Typography>
      </Grid>
      
      <Grid item md={2} xs={2}>
        <Typography variant="body2" className={classes.bold}>
          CORRE DE CONTACTO:
        </Typography>
      </Grid>
      <Grid item md={4} xs={4}>
        <Typography variant="caption">{ctl.infosol.correo || "N/D"}</Typography>
      </Grid>
      <Grid item md={2} xs={2}>
        <Typography variant="body2" className={classes.bold}>
          SOLICITUD:
        </Typography>
      </Grid>
      <Grid item md={4} xs={4}>
        <Typography variant="body2">{ctl.infosol.problematica || "N/D"}</Typography>
      </Grid>

      <Grid item md={4} xs={6}>
        <Typography variant="body2" className={classes.bold}>
          MIEMBROS DE EQUIPO:
          <IconButton
            aria-label="more"
            aria-controls="long-menu"
            aria-haspopup="true"
            onClick={handleExpandClick1}
          >
            {expanded1 ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </Typography>

        <Collapse in={expanded1} timeout="auto" unmountOnExit>
          {ctl.personas
            ? ctl.personas.map(
                (persona, index) => (
                  index == 0 ? (
                    <React.Fragment>
                      <Typography
                        variant="caption"
                        className={classes.bold}
                      >
                        {"LÍDER: "}
                      </Typography>
                      <Typography variant="caption">
                      {persona.nombre}
                      </Typography>
                      <Divider />
                    </React.Fragment>
                  )
                  : (
                    <React.Fragment>
                      <Typography variant="caption">
                      {index + 1 + ". " + persona.nombre}
                      </Typography>
                      <Divider />
                    </React.Fragment>
                  )

                )
                // )
              )
            : "N/D"}
        </Collapse>
      </Grid>
      <Grid item md={2} xs={2}>
        <Typography variant="body2" className={classes.bold}>
          # REVISIONES TESTER:
        </Typography>
      </Grid>
      <Grid item md={2} xs={3}>
        <Typography variant="body2">{ (parseFloat(ctl.infosol.revisiones_tester)+parseFloat(suma_revisiones_testeo_ma) ) || "0"}</Typography>
      </Grid>
      <Grid item md={2} xs={2}>
        <Typography variant="body2" className={classes.bold}>
          # HORAS TESTEO:
        </Typography>
      </Grid>
      <Grid item md={2} xs={3}>
        <Typography variant="body2">{ (parseFloat(ctl.infosol.hrs_testeo)+parseFloat(suma_testeo_ma) ) || "0"}</Typography>
      </Grid>
      <Grid item md={12} xs={12}>
        <Typography variant="body2" className={classes.bold}>
          DESCRIPCIÓN DE LA SOLICITUD:
        </Typography>
      </Grid>
      <Grid item md={12} xs={12}>
        <Typography variant="body2">{ctl.desc_solicitud || "N/D"}</Typography>
      </Grid>
    </Grid>
  );
}
